import React from "react";
import { useTranslation } from "react-i18next";

import { TypeForm } from "../../Forms/domain/Forms";
import { BasicForm } from "../../Forms/Views/Basic/BasicForm";
import withForm from "../../Forms/withForm";

type PropsContactForm = {
  place?: string;
};
export const ContactForm = (props: PropsContactForm) => {
  const BasicFormUse = withForm(
    BasicForm,
    TypeForm.BASIC,
    props.place,
    "white",
  );
  const { t } = useTranslation("global");
  return (
    <div
      className={"m-contact-form "}
      id={`contact${props?.place ? `-${props.place}` : ""}`}
    >
      <div className={"c-contact-form"}>
        <div className={"contact-form__headline"}>
          <div>
            <p className={"h2"}>
              {t("¿Quieres un cambio?")}
              <br />
              <span className="subtitle lighter">{t("Contáctanos")}</span>
            </p>
            <p className={"contact-form__text"}>
              {t("Juntos podemos hacer las cosas fáciles.")}
            </p>
          </div>
        </div>
        <BasicFormUse />
      </div>

      <div className="contact-form-w-foot-line">
        <div className={"contact-form-c-foot-line"}>
          <div className={"contact-form__foot-line"}>
            <p className={"contact-form__foot-line-item"}>
              {t("Llámanos")} <br />
              <a
                href="tel:+34618241658"
                className={"contact-form__link"}
                target="_blank"
                rel="noreferrer"
              >
                618 24 16 58{" "}
              </a>
            </p>
            <p className={"contact-form__foot-line-item"}>
              {t("email")}
              <br />
              <a
                className={"contact-form__link"}
                href="mailto:info@thecookies.agency"
                target="_blank"
                rel="noreferrer"
              >
                info@thecookies.agency
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
